import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './GlancePage.css';

import WordCloud from '../../widgets/WordCloud/WordCloud';
import TimelineChart from '../../widgets/TimelineChart/TimelineChart';
import TechStack from '../../widgets/TechStack/TechStack';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center'
  },
  wordcloud: {
    maxWidth: '1024px'
  },
  box: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '3em',
    flexWrap: 'wrap',
    maxWidth: '1024px'
  },
  card: {
    width: '480px',
    margin: '1em'
  }
}));

const GlancePage = props => {
  const classes = useStyles();
  const { wordcloud } = props.data;

  return (
    <Box className={classes.container}>
      <Box className={classes.wordcloud}>
        <WordCloud widget={wordcloud} />
      </Box>
      <Box className={classes.box}>
        <Box className={classes.card}>
          <TimelineChart />
        </Box>
        <Box className={classes.card}>
          <TechStack />
        </Box>
      </Box>
    </Box>
  );
};

export default GlancePage;
